import {patch} from './utils';
import {VNODE} from './symbols';

/**
 * Patches an empty tree to a container so we run hooks and cleanup
 * @param {HTMLElement} element Element being disconnected
 * @param {Function} [dispatch] function contextualized to the element
 * @param {Function} [next] function to call after disconnect
 */
export default function onDisconnect(element, dispatch, next = () => null) {
	const prev = element[VNODE];

	const styles = [];
	const {children} = prev;
	const {length: childrenCount} = children;
	for (let i = 0; i < childrenCount; i++) {
		const child = children[i];
		if (
			child &&
			typeof child.sel === 'string' &&
			(child.sel.startsWith('style') || child.sel.startsWith('link'))
		)
			styles.push(child);
	}

	const nextEl = {
		...prev,
		children: styles
	};

	patch(prev, nextEl, {disconnect: true});

	delete element[VNODE]; // eslint-disable-line no-param-reassign
	next();
}
